var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"amap"}},[_c('img',{staticClass:"right-map",attrs:{"src":require("@/assets/img/map.png")}})])}]

export { render, staticRenderFns }